import {distinctUntilChanged} from 'rxjs/operators';
import {MonoTypeOperatorFunction} from 'rxjs';

export function distinctUntilChangedArray<T>(): MonoTypeOperatorFunction<Array<T>> {
    return distinctUntilChanged((prevCollection: Array<T>, currentCollection: Array<T>,) => {
        if (prevCollection === currentCollection) {
            return true;
        }

        if (!Array.isArray(prevCollection) || !Array.isArray(currentCollection)) {
            return false;
        }

        if (Array.isArray(prevCollection) && prevCollection.length === 0 && Array.isArray(currentCollection) && currentCollection.length === 0) {
            return true;
        }

        if (prevCollection.length !== currentCollection.length) {
            return false;
        }

        const isOneOfItemReferenceChanged = currentCollection.some((item, i) => {
            return prevCollection[i] !== item;
        });

        return !isOneOfItemReferenceChanged;
    });
}
